import { getFunctions, httpsCallable } from "firebase/functions";
import { log } from "../../helper/helper";
import config from "./../../config.json";
import { getApp } from "firebase/app";

export function adminFindCustomer(inputType, inputValue) {
  const data = { type: inputType, value: inputValue };
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const findCustomer = httpsCallable(functions, config.adminFindCustomer);
  log(data);
  return findCustomer(data);
}

export function adminCustomerResetLatestActivity(uid) {
  const data = { uid: uid };
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const resetLatestActivity = httpsCallable(
    functions,
    config.adminCustomerResetLatestActivity
  );
  log(data);
  return resetLatestActivity(data);
}

export function adminCustomerChangeAllow(uid, status, reason) {
  let data = {};
  if (reason !== "") {
    data = {
      uid: uid,
      is_user_allowed_by_bearer: status,
      not_allowed_reason: reason,
    };
  } else {
    data = { uid: uid, is_user_allowed_by_bearer: status };
  }
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const changeAllow = httpsCallable(functions, config.adminCustomerChangeAllow);
  log(data);
  return changeAllow(data);
}

export function adminCustomerChangeCRM(uid, crm) {
  const data = { uid: uid, crm_tag: crm };
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const customerChangeCRM = httpsCallable(
    functions,
    config.adminCustomerChangeCRM
  );
  log(data);
  return customerChangeCRM(data);
}

export function adminCustomerChangeLoyaltyTier(uid, loyalty) {
  const data = { uid: uid, loyalty_tier: loyalty };
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const changeLoyaltyTier = httpsCallable(
    functions,
    config.adminCustomerChangeLoyaltyTier
  );
  log(data);
  return changeLoyaltyTier(data);
}

export function adminCustomerChangeOrderLimit(uid, limits) {
  const data = { uid: uid, order_limits: limits };
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const changeOrderLimit = httpsCallable(
    functions,
    config.adminCustomerChangeOrderLimit
  );
  log(data);
  return changeOrderLimit(data);
}

export function adminCustomerAddNote(uid, title, note, probabilitySelected) {
  const data = {
    uid: uid,
    note_title: title,
    note_text: note,
    note_user_engagement_scale: probabilitySelected,
  };

  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const customerAddNote = httpsCallable(functions, config.adminCustomerAddNote);
  log(data);
  return customerAddNote(data);
}

export function adminGetCustomerInfo(customerID) {
  const data = { customer_user_id: customerID };
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  log(data);
  const findTransport = httpsCallable(functions, config.adminGetCustomerInfo);
  return findTransport(data);
}

export function getAdminInfo() {
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const adminGetAdminInfo = httpsCallable(functions, config.adminGetAdminInfo);
  return adminGetAdminInfo();
}
